<template>
  <div
    :id="id"
    class="chart"
  />
</template>

<script>
import * as echarts from 'echarts';
// import resize from './mixins/resize'

export default {
  // mixins: [resize],
  props: {
    id: {
      type: String,
      default: 'id'
    },
    title: {
      type: String,
      default: ''
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data() {
    return {
      chart: null,
      screenWidth: window.screen.width == 960? 'small' :window.screen.width == 1280 || Math.floor(window.screen.width * window.devicePixelRatio) == 3840 ? 'max' : 'normal'
    }
  },
  mounted() {
    // this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart(dataList) {
      if (!this.chart) this.chart = echarts.init(document.getElementById(this.id))
      let data1 = dataList[0]
      let data2 = dataList[1]
      let data3 = dataList[2]
      let yData = [
        data1['unitEfficiency'].toFixed(2),
        data1['comprehensiveEvaluation'].toFixed(2),
        data1['unitWaterRate'].toFixed(2)
      ]
      let yData2 = [
        data2['unitEfficiency'].toFixed(2),
        data2['comprehensiveEvaluation'].toFixed(2),
        data2['unitWaterRate'].toFixed(2)
      ]
      let yData3 = [
        data3['unitEfficiency'].toFixed(2),
        data3['comprehensiveEvaluation'].toFixed(2),
        data3['unitWaterRate'].toFixed(2)
      ];
      this.chart.setOption({
        grid: {
          left: '5%',
          right: '10%',
          top: '5%',
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item',
          formatter: function (parms) {
            let unitMap = {
              'F值': '',
              '机组效率': '%',
              '耗水率': 'm³/kW·h'
            }
            return parms.marker + " " + parms.name + "：" + parms.value + unitMap[parms.name];
          }
        },
        // dataset: {
        //   dimensions: ['product', '2015', '2016', '2017'],
        //   source: [
        //     // ['Matcha', 43.3, 85.8, 93.7],
        //     // ['Milk Tea', 83.1, 73.4, 55.1],
        //     // ['Cheese Cocoa', 86.4, 65.2, 82.5]
        //     { product: 'Matcha Latte', 2015: 43.3, 2016: 85.8, 2017: 93.7 },
        //     { product: 'Milk Tea', 2015: 83.1, 2016: 73.4, 2017: 55.1 },
        //     { product: 'Cheese Cocoa', 2015: 86.4, 2016: 65.2, 2017: 82.5 },
        //   ]
        // },
        xAxis: {
          type: 'category', // category(坐标轴类型)
          data: ['机组效率', 'F值', '耗水率'],
          axisTick: { // 坐标轴刻度相关配置
            show: true // 是否显示坐标轴刻度
          },
          axisLine: { // 坐标轴轴线相关配置
            lineStyle: { // 坐标轴轴线样式
              // color: 'rgba(255,255,255,0.15)' // 坐标轴轴线颜色
            }
          },
          axisLabel: { // 坐标轴刻度标签相关配置
            color: '#abd3ff',
            fontSize: this.screenWidth == 'small'? 8 : 14,
            margin: 20
          }
        },
        yAxis: [
          // {
          //   type: 'value', // value(数值轴,适用于连续数据)
          //   axisTick: { // 坐标轴刻度相关配置
          //     show: true  // 是否显示坐标轴刻度
          //   },
          //   axisLine: { // 坐标轴轴线相关配置
          //     show: true // 是否显示坐标轴轴线
          //   },
          //   axisLabel: { // 坐标轴刻度标签相关配置
          //     color: '#ffffff',
          //     fontSize: 14
          //   },
          //   splitLine: { // 坐标轴在 grid 区域中的分隔线
          //     lineStyle: { // 分割线配置
          //       // color: 'rgba(255,255,255,0.15)' // 分割线颜色
          //     }
          //   }
          // },
          {
            name: 'F值/效率',
            type: 'value',
            position: 'left',
            // max: 100,
            splitLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, .1)'
              }
            },
            axisLine: {
              lineStyle: {
                color: '#abd3ff'
              }
            },
            axisLabel: {
              fontSize: this.screenWidth == 'small'? 8 : 12,
            }
          }, {
            name: '耗水率',
            type: 'value',
            position: 'right',
            splitLine: {
              lineStyle: {
                color: 'rgba(22, 44, 65, 1)'
              }
            },
            max: 25,
            axisLine: {
              lineStyle: {
                color: '#abd3ff'
              }
            },
          }
        ],
        series: [
          // 底部的椭圆形(象形柱图):pictorialBar
          {
            type: "pictorialBar", // pictorialBar(象形柱图)
            label: { // 图形上的文本标签,可用于说明图像的一些数据信息,比如值,名称等
              show: false, //是否显示标签
              position: ['17', '-30'], // 标签的位置(可以是绝对的像素值或者百分比['50%','50%',也可以是top,left等])
              color: '#01E4FF',
              fontSize: 14
            },
            symbolSize: this.screenWidth == 'small'? [15,10] : this.screenWidth == 'max'? [20,10] : [30, 10], // 图形的大小用数组分别比表示宽和高,也乐意设置成10相当于[10,10]
            symbolOffset: this.screenWidth == 'small'? [-16, 5] : this.screenWidth == 'max'? [-21, 5] : [-31.5, 5], // 图形相对于原本位置的偏移
            z: 12, // 象形柱状图组件的所有图形的 z 值.控制图形的前后顺序.z 值小的图形会被 z 值大的图形覆盖.
            itemStyle: { // 图形样式
              // echarts.graphic.LinearGradient(echarts内置的渐变色生成器)
              // 4个参数用于配置渐变色的起止位置,这4个参数依次对应右 下 左 上
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                // 这里 offset: 0 1 ,表示从下往上的渐变色
                {
                  offset: 0, // 0%处的颜色
                  color: "rgba(254,194,0,.5)"
                },
                {
                  offset: 1, // 100%处的颜色
                  color: "rgba(254,194,0, 1)"
                }
              ])
            },
            data: yData
          },
          // 中间的长方形柱状图(柱状图):bar
          {
            type: 'bar', // 柱状图
            barWidth: this.screenWidth == 'small'? 15 : this.screenWidth == 'max'? 20 : 30, // 柱条的宽度,不设时自适应
            barGap: '5%', // 柱子与柱子之间的距离
            itemStyle: { // 图形样式
              // color支持(rgb(255,255,255)、rgba(255,255,255,1)、#fff,也支持渐变色和纹理填充)
              // 下面就是使用线性渐变
              color: {
                "x": 0,
                "y": 0,
                "x2": 0,
                "y2": 1,
                "type": "linear",
                "global": false,
                "colorStops": [{
                  "offset": 0, // 0%处的颜色
                  "color": "rgba(254,194,0,.5)"
                }, {
                  "offset": 1, // 100%处的颜色
                  "color": "rgba(254,194,0,1)"
                }]
              }
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              fontSize: this.screenWidth == 'small'? 5 : this.screenWidth == 'max'? 6 : 9
            },
            data: yData
          },
          // 顶部的椭圆形(象形柱图):pictorialBar
          {
            type: "pictorialBar",
            symbolSize: this.screenWidth == 'small'? [15,10] : this.screenWidth == 'max'? [20,10] : [30, 10],
            symbolOffset: this.screenWidth == 'small'? [-16,-5] : this.screenWidth == 'max'? [-21, -5] : [-31.5, -5],
            z: 12,
            symbolPosition: "end",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(254,194,0,.5)"
                },
                {
                  offset: 1,
                  color: "rgba(254,194,0,1)"
                }
              ], false)
            },
            data: yData
          },
          {
            type: "pictorialBar", // pictorialBar(象形柱图)
            label: { // 图形上的文本标签,可用于说明图像的一些数据信息,比如值,名称等
              show: false, //是否显示标签
              position: ['17', '-30'], // 标签的位置(可以是绝对的像素值或者百分比['50%','50%',也可以是top,left等])
              color: '#01E4FF',
              fontSize: 14
            },
            symbolSize: this.screenWidth == 'small'? [15,10] : this.screenWidth == 'max'? [20,10] : [30, 10], // 图形的大小用数组分别比表示宽和高,也乐意设置成10相当于[10,10]
            symbolOffset: [0, 5], // 图形相对于原本位置的偏移
            z: 12, // 象形柱状图组件的所有图形的 z 值.控制图形的前后顺序.z 值小的图形会被 z 值大的图形覆盖.
            itemStyle: { // 图形样式
              // echarts.graphic.LinearGradient(echarts内置的渐变色生成器)
              // 4个参数用于配置渐变色的起止位置,这4个参数依次对应右 下 左 上
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                // 这里 offset: 0 1 ,表示从下往上的渐变色
                {
                  offset: 0, // 0%处的颜色
                  color: "rgba(23,197,253,0.5)"
                },
                {
                  offset: 1, // 100%处的颜色
                  color: "rgba(23,197,253,1)"
                }
              ])
            },
            data: yData2
          },
          // 中间的长方形柱状图(柱状图):bar
          {
            type: 'bar', // 柱状图
            barWidth: this.screenWidth == 'small'? 15 : this.screenWidth == 'max'? 20 : 30, // 柱条的宽度,不设时自适应
            barGap: '5%', // 柱子与柱子之间的距离
            itemStyle: { // 图形样式
              // color支持(rgb(255,255,255)、rgba(255,255,255,1)、#fff,也支持渐变色和纹理填充)
              // 下面就是使用线性渐变
              color: {
                "x": 0,
                "y": 0,
                "x2": 0,
                "y2": 1,
                "type": "linear",
                "global": false,
                "colorStops": [{
                  "offset": 0, // 0%处的颜色
                  "color": "rgba(23,197,253,0.5)"
                }, {
                  "offset": 1, // 100%处的颜色
                  "color": "rgba(23,197,253,1)"
                }]
              }
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              fontSize: this.screenWidth == 'small'? 5 : this.screenWidth == 'max'? 6 : 9
            },
            data: yData2
          },
          // 顶部的椭圆形(象形柱图):pictorialBar
          {
            type: "pictorialBar",
            symbolSize: this.screenWidth == 'small'? [15,10] : this.screenWidth == 'max'? [20,10] : [30, 10],
            symbolOffset: [0, -5],
            z: 12,
            symbolPosition: "end",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(23,197,253,0.5)"
                },
                {
                  offset: 1,
                  color: "rgba(23,197,253,1)"
                }
              ], false)
            },
            data: yData2
          },
          {
            type: "pictorialBar", // pictorialBar(象形柱图)
            label: { // 图形上的文本标签,可用于说明图像的一些数据信息,比如值,名称等
              show: false, //是否显示标签
              position: ['27', '-30'], // 标签的位置(可以是绝对的像素值或者百分比['50%','50%',也可以是top,left等])
              color: '#01E4FF',
              fontSize: 14
            },
            symbolSize: this.screenWidth == 'small'? [15,10] : this.screenWidth == 'max'? [20,10] : [30, 10], // 图形的大小用数组分别比表示宽和高,也乐意设置成10相当于[10,10]
            symbolOffset: this.screenWidth == 'small'? [16,5] : this.screenWidth == 'max'? [21, 5] : [31.5, 5], // 图形相对于原本位置的偏移
            z: 12, // 象形柱状图组件的所有图形的 z 值.控制图形的前后顺序.z 值小的图形会被 z 值大的图形覆盖.
            itemStyle: { // 图形样式
              // echarts.graphic.LinearGradient(echarts内置的渐变色生成器)
              // 4个参数用于配置渐变色的起止位置,这4个参数依次对应右 下 左 上
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                // 这里 offset: 0 1 ,表示从下往上的渐变色
                {
                  offset: 0, // 0%处的颜色
                  color: "rgba(23,112,253,.5)"
                },
                {
                  offset: 1, // 100%处的颜色
                  color: "rgba(23,112,253,1)"
                }
              ])
            },
            data: yData3
          },
          // 中间的长方形柱状图(柱状图):bar
          {
            type: 'bar', // 柱状图
            barWidth: this.screenWidth == 'small'? 15 : this.screenWidth == 'max'? 20 : 30, // 柱条的宽度,不设时自适应
            barGap: '5%', // 柱子与柱子之间的距离
            itemStyle: { // 图形样式
              // color支持(rgb(255,255,255)、rgba(255,255,255,1)、#fff,也支持渐变色和纹理填充)
              // 下面就是使用线性渐变
              color: {
                "x": 0,
                "y": 0,
                "x2": 0,
                "y2": 1,
                "type": "linear",
                "global": false,
                "colorStops": [{
                  "offset": 0, // 0%处的颜色
                  "color": "rgba(23,112,253,.5)"
                }, {
                  "offset": 1, // 100%处的颜色
                  "color": "rgba(23,112,253,1)"
                }]
              }
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              fontSize: this.screenWidth == 'small'? 5 : this.screenWidth == 'max'? 6 : 9
            },
            data: yData3
          },
          // 顶部的椭圆形(象形柱图):pictorialBar
          {
            type: "pictorialBar",
            symbolSize: this.screenWidth == 'small'? [15,10] : this.screenWidth == 'max'? [20,10] : [30, 10],
            symbolOffset: this.screenWidth == 'small'? [16,-5] : this.screenWidth == 'max'? [21, -5] : [31.5, -5],
            z: 12,
            symbolPosition: "end",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(23,112,253,.5)"
                },
                {
                  offset: 1,
                  color: "rgba(23,112,253,1)"
                }
              ], false)
            },
            data: yData3
          },
        ]
      });
    }
  }
}
</script>

<style scoped lang="scss">
.chart {
  height: 100%;
}
</style>
